import { ColumnsType } from "antd/es/table";
import { Tag } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { FortnoxMaterialStatus } from "shared/api";

export const useFortnoxMaterialColumns =
  (): ColumnsType<FortnoxMaterialStatus> => [
    {
      title: "Name",
      dataIndex: "chainlinx_name",
      key: "chainlinx_name",
    },
    {
      title: "Fortnox Article Number",
      dataIndex: "fortnox_article_number",
      key: "fortnox_article_number",
    },
    {
      title: "Fortnox Description",
      dataIndex: "fortnox_description",
      key: "fortnox_description",
    },
    {
      title: "Quantity",
      dataIndex: "total_quantity",
      key: "total_quantity",
    },
    {
      title: "Not Found",
      dataIndex: "error_not_found",
      key: "error_not_found",
      render: (error_not_found: boolean) =>
        error_not_found ? (
          <Tag color="error" icon={<CloseCircleOutlined />}>
            Error
          </Tag>
        ) : (
          <Tag color="green" icon={<CheckCircleOutlined />}>
            Found
          </Tag>
        ),
    },
  ];
